import type { FC, ReactNode } from 'react'

import Fathom from '@/components/sections/fathom'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

/* No CDN base is passed in or resolved at build time on purpose — the flythrough
 * requests its images from /api/media on this same origin, which resolves the
 * current storage host per request. See the comment in the component. */
const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Fathom />
        </Layout>
    )
}

export default Home
